<template>
  <div :class="'custom_input '+width">
    <div
      v-if="label"
      class="label"
    >
      {{ capitalisedLabel }}
    </div>
    <div
      v-if="subLabel"
      class="label sub_label"
      v-html="subLabel"
    />
    <input
      :class="{'form-disabled' : disabled}"
      :disabled="disabled"
      :placeholder="placeholder"
      :type="type"
      :value="value ? value : modelValue"
      autocomplete="off"
      class="input"
      @input="updateValue($event.target.value)"
    >
    <small
      v-for="(error, index) in validationErrors"
      :key="index"
      class="validation"
    >{{ error }}</small>
  </div>
</template>
<script>
import _ from 'lodash';
export default {
  props: {
    label: {
      type: String,
      required: false,
      default: '',
    },
    subLabel: {
      type: String,
      required: false,
      default: '',
    },
    type: {
      type: String,
      required: false,
      default: 'text'
    },
    modelValue: {
      type: [String, Number],
      required: false,
      default: '',
    },
    placeholder: {
      type: String,
      required: false,
      default: null,
    },
    width: {
      type: String,
      required: false,
      default: 'full'
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    validationErrors: {
      type: Object,
      required: false,
      default: null,
    },
    value: {
      type: [String, Number],
      default: null
    }
  },
  emits: ['update:modelValue'],
  computed: {
    capitalisedLabel() {
      let words = this.label.split(' ');
      _.each(words, (word, index) => {
        words[index] = _.capitalize(word);
      });
      return words.join(' ');
    }
  },
  methods: {
    updateValue(value) {
      this.$emit('update:modelValue', value)
    },
  },
};
</script>
<style scoped>
.custom_input {
  margin-bottom: 1.5rem;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type=number] {
  -moz-appearance: textfield;
}

input:disabled {
  opacity: .5;
  pointer-events: none;
}

.full {
  width: 100%;
}

.two-thirds {
  width: calc(66.66% - .5rem);
}

.half {
  width: calc(50% - .5rem);
}

.third {
  width: calc(33.33% - .5rem);
}

.quarter {
  width: calc(25% - .5rem);
}

.input {
  width: 100%;
  color: #4E4E54;
  background-color: #fff;
  border: 1px solid #E8E5E2;
  padding: 14.5px 24.5px 15.5px;
  border-radius: 12px;
  height: 3rem;
  font-size: 14px;
  letter-spacing: -0.5px;
  -webkit-transition: .3s;
  -o-transition: .3s;
  transition: .3s;
}

.label {
  margin-bottom: .25rem;
  font-size: 0.75rem;
  line-height: 1.3;
  letter-spacing: -0.1px;
  color: #909096;
}

.sub_label {
  float: right;
  font-size: .625rem;
  line-height: 1.3;
  letter-spacing: -0.015em;
  color: #909096;
}

.input::-webkit-input-placeholder {
  color: #9999a3;
  -webkit-transition: .3s;
  transition: .3s;
}

.input::-moz-placeholder {
  color: #9999a3;
  -moz-transition: .3s;
  transition: .3s;
}

.input:-ms-input-placeholder {
  color: #9999a3;
  -ms-transition: .3s;
  transition: .3s;
}

.input::-ms-input-placeholder {
  color: #9999a3;
  -ms-transition: .3s;
  transition: .3s;
}

.input::placeholder {
  color: #9999a3;
  -webkit-transition: .3s;
  -o-transition: .3s;
  transition: .3s;
}

.input:focus::-webkit-input-placeholder {
  color: transparent;
}

.input:focus::-moz-placeholder {
  color: transparent;
}

.input:focus:-ms-input-placeholder {
  color: transparent;
}

.input:focus::-ms-input-placeholder {
  color: transparent;
}

.input:focus::placeholder {
  color: transparent;
}

.validation {
  text-align: center;
  color: red;
  margin-left: 10px;
}

input[disabled] {
  pointer-events: none;
}

.form-disabled {
  background-color: #e9ecef;
  opacity: 1;
}
</style>
